import { Component, inject } from '@angular/core';
import { CONFIG } from '@nano/core/config';
import { L10N_LOCALE } from 'angular-l10n';

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.less'],
  standalone: false
})
export class AsideComponent {
  private config = inject(CONFIG);
  locale = inject(L10N_LOCALE);
  readonly imageOnLoginAside = this.config.imageOnLoginAside;
}
